import React from "react";
import { Col, Row, Card, Table } from "react-bootstrap";
import HeaderFields from "../../HeaderFields";
import { Label } from "../../fields";
import { FaArrowAltCircleUp, FaArrowAltCircleDown, FaMinusCircle } from "react-icons/fa";
import { formatPercent } from "utils/formatNumber";

const MarginCRProfilingForm = ({ control, formState }) => {
  // debugger; // eslint-disable-line no-debugger

  const uiState = formState.defaultValues;

  const BetweenUnits = ({ uiState }) => {
    return (
      <>
        <strong>{parseInt(uiState.units.increase.units) - 1}</strong>
        &nbsp;and&nbsp;
        <strong> {parseInt(uiState.units.lower.units) + 1}</strong>
      </>
    );
  };

  const BetweenCR = ({ uiState }) => {
    return (
      <>
        <strong>{formatPercent(uiState.ocr.lower.units - 1 + 0.0001, 2)}</strong>
        &nbsp;and&nbsp;
        <strong>{formatPercent(uiState.ocr.increase.units - 1 - 0.0001, 2)}</strong>
      </>
    );
  };

  return (
    <Row>
      {control && <HeaderFields control={control} formState={formState} />}
      <Col xs={12} className="mt-4">
        <Label>Margin Profiling Rules</Label>
      </Col>
      <Col xs={12}>
        <Card className="p-4">
          <Card.Body>
            <div>
              To <strong>increase</strong> the price of a product, the following conditions must be met:
            </div>
            <div className="py-2">
              <span className="">Increase Days: {uiState.units.increase.days} days </span>
              <span className="ps-3">Decrease Days: {uiState.units.lower.days} days</span>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Units / CR</th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      CR <FaArrowAltCircleUp /> <br />
                      <strong>{formatPercent(uiState.ocr.increase.units - 1, 2)}</strong> or more
                    </span>
                  </th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      CR <FaMinusCircle /> <br />
                      <BetweenCR uiState={uiState} />
                    </span>
                  </th>
                  <th className="text-center" style={{ color: "#000" }}>
                    <span className="fs-standard">
                      CR <FaArrowAltCircleDown /> <br />
                      <strong>{formatPercent(uiState.ocr.lower.units - 1, 2)}</strong> or more
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      Units <FaArrowAltCircleUp /> <br />
                      <strong>{uiState.units.increase.units}</strong> or more
                    </span>
                  </td>
                  <td className="text-center"> Price Up by {formatPercent(uiState.units.increase.percent / 100, 0)}</td>
                  <td className="text-center">Price Up by {formatPercent(uiState.units.increase.percent / 100, 0)}</td>
                  <td className="text-center">No Change</td>
                </tr>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      Units <FaMinusCircle /> <br />
                      <BetweenUnits uiState={uiState} />
                    </span>
                  </td>
                  <td className="text-center">Price Up by {formatPercent(uiState.units.increase.percent / 100, 0)}</td>
                  <td className="text-center">No Change</td>
                  <td className="text-center">Price Down by {formatPercent(uiState.units.lower.percent / 100, 0)}</td>
                </tr>
                <tr>
                  <td className="text-center text-uppercase">
                    <span className="fs-standard">
                      Units <FaArrowAltCircleDown /> <br />
                      <strong>{uiState.units.lower.units}</strong> or less
                    </span>
                  </td>
                  <td className="text-center">No Change</td>
                  <td className="text-center">Price Down by {formatPercent(uiState.units.lower.percent / 100, 0)}</td>
                  <td className="text-center">Price Down by {formatPercent(uiState.units.lower.percent / 100, 0)}</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export { MarginCRProfilingForm };
